const zeroIndexedMonthToShortName: { [key: number]: string } = {
  0: 'jan',
  1: 'feb',
  2: 'mar',
  3: 'apr',
  4: 'may',
  5: 'june',
  6: 'july',
  7: 'aug',
  8: 'sept',
  9: 'oct',
  10: 'nov',
  11: 'dec',
};

export function monthNumberToName(month: number) {
  switch (month) {
    case 1:
      return 'januari';
    case 2:
      return 'februari';
    case 3:
      return 'mars';
    case 4:
      return 'april';
    case 5:
      return 'maj';
    case 6:
      return 'juni';
    case 7:
      return 'juli';
    case 8:
      return 'augusti';
    case 9:
      return 'september';
    case 10:
      return 'oktober';
    case 11:
      return 'november';
    case 12:
      return 'december';
  }
  throw new Error('Unknown month number: ' + month);
}

export function monthNameToNumber(monthName: string): number {
  const name = monthName.slice(0, 3).toLowerCase();
  switch (name) {
    case 'jan':
      return 1;
    case 'feb':
      return 2;
    case 'mar':
      return 3;
    case 'apr':
      return 4;
    case 'maj':
      return 5;
    case 'jun':
      return 6;
    case 'jul':
      return 7;
    case 'aug':
      return 8;
    case 'sep':
      return 9;
    case 'okt':
      return 10;
    case 'nov':
      return 11;
    case 'dec':
      return 12;
    default:
      throw new Error(
        `Unrecognized month name. First three characters: ${name}, full name: ${monthName}`,
      );
  }
}

export function monthToShortName(monthNumber: number, zeroIndexed: boolean) {
  return zeroIndexed
    ? zeroIndexedMonthToShortName[monthNumber]
    : zeroIndexedMonthToShortName[monthNumber - 1];
}

export const Milliseconds = {
  second: 1000,
  minute: 1000 * 60,
  hour: 1000 * 60 * 60,
  day: 1000 * 60 * 60 * 24,
};
